import React from 'react';

import {TooltipPlacement, TooltipWrapper} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {ctrl} from 'util/Keyboard';

export interface SaveAndRunButtonProps {
  className?: string;
  isDisabledMessage: string | null;
  isSubQuery: boolean;
  onSaveAndRun: () => void;
}

export default function SaveAndRunButton(props: SaveAndRunButtonProps): JSX.Element {
  const tooltipTitle =
    props.isDisabledMessage ??
    (props.isSubQuery
      ? `Save query and run selected sub query\n(${ctrl} + Enter from SQL editor)`
      : `Save and run query\n(${ctrl} + Enter from SQL editor)`);

  function handleClick(): void {
    props.onSaveAndRun();
  }
  return (
    <TooltipWrapper tooltipTitle={tooltipTitle} tooltipPlacement={TooltipPlacement.TOP}>
      <Button
        buttonStyle={ButtonStyle.SECONDARY}
        className={props.className}
        disabled={props.isDisabledMessage != null}
        icon="run-query"
        onClick={handleClick}
        size={ButtonSize.SMALL}
        text={props.isSubQuery ? 'Run selected' : 'Run query'}
        dataTestAttrs={{component: 'SaveAndRunButton', element: 'button'}}
      />
    </TooltipWrapper>
  );
}
